import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CardModule } from '@modules/card/card.module';
import { MediaModule } from '@modules/media/media.module';
import { SharedModule } from '@modules/shared/shared.module';

import { CarouselSectionComponent } from './carousel-section/carousel-section.component';
import { ItemSliderComponent } from './item-slider/item-slider.component';
import { RibbonSliderSectionComponent } from './ribbon-slider-section/ribbon-slider-section.component';
import { SliderBaseComponent } from './slider-base/slider-base.component';
import { SliderNavigationComponent } from './slider-navigation/slider-navigation.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    CardModule,
    MediaModule,
    SliderBaseComponent,
    CarouselSectionComponent,
    RibbonSliderSectionComponent,
    ItemSliderComponent,
    SliderNavigationComponent,
  ],
  exports: [CarouselSectionComponent, RibbonSliderSectionComponent, ItemSliderComponent],
})
export class SliderModule {}
